// hooks/inbox/controller/useInboxOnboardingController.ts
import { useEffect, useState } from 'react';
import { useProductFruitsApi } from 'react-product-fruits';
import { useSelector } from 'react-redux';

import RetailerModel from '../../../models/RetailerModelMC';

const useInboxOnboardingController = () => {
  const [isMiaOnboardingVisible, setIsMiaOnboardingVisible] = useState(false);
  const [showOnboardingTour, setShowOnboardingTour] = useState(false);
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);

  useProductFruitsApi((api) => {
    if (showOnboardingTour) {
      api.tours.tryStartTour(ENV.PRODUCT_FRUITS_ONBOARDING);
    }
  }, [showOnboardingTour]);

  useEffect(() => {
    const isMobile = window.innerWidth <= 767;
    const hasSeenMobileBanner =
      sessionStorage.getItem('mobile_limited_banner_seen') === 'true';

    const canShowMiaOnboarding = !isMobile || hasSeenMobileBanner;

    if (
      retailer_info?.mia_onboarding_completed === false &&
      canShowMiaOnboarding
    ) {
      setIsMiaOnboardingVisible(true);
    } else if (retailer_info?.mia_onboarding_completed === true) {
      setShowOnboardingTour(isMiaOnboardingVisible);
      setIsMiaOnboardingVisible(false);
    }
  }, [retailer_info]);


  const handleCloseMiaOnboarding = () => {
    setIsMiaOnboardingVisible(false);
    const formData = {
      id: "update_attrs",
      retailer: {
        mia_onboarding_completed: true
      }
    };

    RetailerModel.save(formData).then(() => {
    }).catch((error) => {
      showtoast(error.message);
    });
  };

  return {
    handleCloseMiaOnboarding,
    isMiaOnboardingVisible,
  };
};

export default useInboxOnboardingController;